<template>
  <div class="login-page">
    <b-container fluid>
      <b-row>
        <b-col lg="5" md="6">
          <div class="login-panel">
            <h4 class="login-title">{{ $t('login.login') }}</h4>

            <b-form @submit="handleLogin">
              <b-container fluid>
                <!-- Уведомление об ошибке логина -->
                <b-alert v-if="is_login_error" variant="danger" show class="mb-3">{{ $t('login.incorrectCredentials') }}</b-alert>
                
                <b-form-row class="mb-3">
                  <b-form-input type="email" id="email" v-model="login.username" placeholder="Email" required class="modern-input"></b-form-input>
                </b-form-row>
                <b-form-row class="mb-3">
                  <b-form-input type="password" id="password" v-model="login.password" placeholder="Password" required class="modern-input"></b-form-input>
                </b-form-row>

                <b-form-row class="mb-1">
                  <b-col>
                    <b-button type="submit" name="login" variant="primary" class="modern-btn login-btn w-100 mb-1">
                      {{ $t('login.login') }}
                    </b-button>
                  </b-col>
                </b-form-row>
                <b-form-row class="mb-2">
                  <b-col>
                    <b-button v-b-toggle.collapse-registration name="show-registration" variant="outline-secondary" class="modern-btn signup-btn w-100">Sign In</b-button>
                  </b-col>
                </b-form-row>
              </b-container>
            </b-form>

            <!-- Уведомления об успешной регистрации и ошибках регистрации -->
            <b-alert v-if="is_registered" variant="success" show class="mt-3">Registration successful. Thank you for registering. Please check your email for a password.</b-alert>

            <b-alert v-if="is_wrong_registration" variant="warning" show class="mt-3">
              {{ $t('login.regNotSuccess') }}
            </b-alert>

            <b-collapse size="sm" id="collapse-registration" v-model="showRegistrationBlock" class="mt-3">
              <div class="registration-form">
                <b-form @submit="handleRegistration">
                  <b-form-row class="mb-3">
                    <b-col>
                      <!-- <label class="form-label">Email:</label> -->
                      <b-form-input type="email" id="r_email" v-model="registration.username" placeholder="Email" class="modern-input"></b-form-input>
                    </b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col>
                      <b-button type="submit" name="registration" class="modern-btn submit-btn w-100">{{ $t('login.submit') }}</b-button>
                    </b-col>
                  </b-form-row>
                </b-form>
              </div>
            </b-collapse>

            <b-alert v-if="!IS_NP" show class="mt-3">
              <p>
                <b>{{ $t('login.howToGetStarted') }}</b>
              </p>
              <p>{{ $t('login.toPurchaseENCsRegister') }}</p>
              <p>{{ $t('login.submitYourEmail') }}</p>
            </b-alert>

            <b-alert v-if="!IS_NP" show class="mt-3">
              <p>
                <b>{{ $t('login.howToPurchase') }}</b>
              </p>
              <p>{{ $t('login.enterCredentials') }}</p>
              <p>{{ $t('login.youMayPurchase') }}</p>
              <p>{{ $t('login.systemAutoPrevents') }}</p>
            </b-alert>
          </div>
        </b-col>

        <!-- Image and text column -->
        <b-col lg="7" md="6" class="d-none d-md-block">
          <div class="image-container">
            <!-- <img src="/backg.jpg" alt="Background" class="background-image" /> -->
            <div class="overlay-text">
              <h3>{{ $t('login.welcomeTitle') }}</h3>
              <p>
                ECDIS-Link is the bridge between ECDIS and information required for safe and comfortable navigation including ENC, Routes, Weather, Navarea etc...
              </p>
              <p>ECDIS-Link is to be used for the main tasks like following:</p>
              <div class="feature-list">
                <p>• Overview</p>
                <p>• Order</p>
                <p>• Delivery</p>
              </div>

              <p>In addition to above ECDIS-Link comprises useful functionality like auto-routing, tracking, UKC calculation, Passage Plan compilation, etc.</p>
              <a href="https://get-enc.com/" target="_blank">More information ...</a>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import router from '@/router';
import { eventBus } from '@/main';
import { myAxios } from '@/services/myAxios';
import { file } from 'paths.macro';
import { IS_GETENC, IS_NP } from '@/utils/build-config';
import store from '@/store';

export default {
  props: ['xxx'],
  data() {
    return {
      prevRoute: null,
      login: {
        username: '',
        password: '',
        nickname: ''
      },
      registration: {
        username: '',
        password: '',
        nickname: ''
      },
      is_registered: false,
      is_wrong_registration: false,
      is_login_error: false,
      is_mconnect: false,
      mconnect_token: null,
      showRegistrationBlock: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = router.history._startLocation;
    });
  },
  created() {
    this.isMobile();
  },
  mounted() {
    store.commit('fickle/setUserInstallationsReady', false);
    store.commit('fickle/setUserDataReady', false);

    this.test();

    this.getName();

    eventBus.$on('is-registered', flag => {
      console.log('is-registered ' + flag);

      if (flag) {
        this.is_registered = true;
        this.is_wrong_registration = false;
        this.is_login_error = false;
        this.showRegistrationBlock = true;
      } else {
        this.is_wrong_registration = true;
        this.is_registered = false;
        this.is_login_error = false;
        this.showRegistrationBlock = true;
      }
    });

    // Обработчик для ошибок входа
    eventBus.$on('login-error', () => {
      this.is_login_error = true;
      this.is_registered = false;
      this.is_wrong_registration = false;
      this.showRegistrationBlock = false;
    });
  },
  methods: {
    IS_DEVBUILD() {
      return process.env.VUE_APP_DEVBUILD === 'true';
    },
    IS_GETENC() {
      return IS_GETENC;
    },
    test() {
      // let _ = require('lodash');
      // alert('test')
      // let array = [1, 2, 3];
      // alert(array)
      // _.fill(array, 'a');
      // alert(array)
    },
    app_name() {
      if (!this.IS_NP()) return 'mKart/Vega/etc.';
      else return 'Njord Pilot';
    },
    app_email_link() {
      if (!this.IS_NP()) return 'mailto:info@mkart.fi';
      else return 'mailto:support@njordpilot.com';
    },
    app_email() {
      if (!this.IS_NP()) return 'info@mkart.fi';
      else return 'support@njordpilot.com';
    },
    IS_NP() {
      return IS_NP;
    },
    getName() {
      let urlParams = new URLSearchParams(window.location.search);
      let urlPath1 = new URLSearchParams(window.location.pathname);
      let urlPath2 = window.location.pathname;
      console.log('dddd1', urlParams);
      console.log('dddd2', urlPath1);
      console.log('dddd3', urlPath2);
      let param = urlParams.get('connect');
      let page = urlParams.get('page');
      console.log('dddd4', param);
      console.log('dddd4', page);

      if (param) {
        this.is_mconnect = true;
        this.mconnect_token = param;

        this.$store.dispatch('auth/loginWithMconnect', param);
      }

      if (page) {
        // this.is_mconnect = true;
        // this.mconnect_token = param;
        // this.$store.dispatch("auth/loginWithMconnect", param)
      }
    },
    handleLogin(event) {
      event.preventDefault();
      // Сбрасываем ошибки при новой попытке входа
      this.is_login_error = false;
      this.is_registered = false;
      this.is_wrong_registration = false;
      this.showRegistrationBlock = false;

      if (event.submitter.name === 'login' && this.login.username && this.login.password) {
        this.$store.dispatch('auth/login', {
          username: this.login.username,
          password: this.login.password,
          prevRoute: this.prevRoute
        });
      } else {
        // _T_O_D_O
      }
    },
    handleRegistration(event) {
      console.log(event.submitter.name);
      event.preventDefault();
      this.$root.$emit('bv::toggle::collapse', 'collapse-registration');
      if (event.submitter.name === 'registration' && this.registration.username) {
        this.$store.dispatch('auth/register', {
          email: this.registration.username,
          password: '',
          userType: 'user',
          applicationTypeId: !IS_NP ? 0 : 1
        });
      } else {
        // TODO
      }
    },
    isMobile() {
      if (window.outerWidth <= 760 && window.matchMedia('(orientation: portrait)').matches && !this.IS_GETENC()) {
        router.push({ path: 'mobile' });
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.login-page {
  margin-top: 2rem;
}

.login-page .row {
  margin: 0;
}

.login-page .col-md-3 {
  padding-right: 1rem;
}

.login-page .col-md-6 {
  padding-right: 1rem;
}

.login-page .col-lg-5 {
  padding-right: 1rem;
}

.login-page .col-md-9 {
  padding-left: 1rem;
}

.login-page .col-lg-7 {
  padding-left: 1rem;
}

/* Cтили для левой панели */
.login-panel {
  background: rgba(220, 219, 219, 0.35);
  padding: 1rem 2rem 2rem 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-right: 2rem;
  height: fit-content;
  width: 100%;
  height: 500px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-title {
  color: rgb(41, 40, 40);
  text-align: center;
  margin-bottom: 1rem;
  margin-top: 1rem;
  font-weight: normal;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  font-size: 1.5rem;
}

.modern-input {
  border: none;
  border-radius: 10px;
  padding: 0.8rem 1rem;
  font-size: 0.95rem;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.modern-input:focus {
  outline: none;
  background: white;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.modern-btn {
  border-radius: 10px;
  padding: 0.6rem 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  font-size: 0.95rem;
  width: 100%;
}

.login-btn {
  background: linear-gradient(45deg, #17a2b8, #138496);
  color: white;
  box-shadow: 0 4px 8px rgba(23, 162, 184, 0.3);
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(23, 162, 184, 0.4);
}

.signup-btn {
  background: rgba(255, 255, 255, 0.9);
  color: #495057;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.signup-btn:hover {
  background: white;
  color: #343a40;
  transform: translateY(-1px);
}

.submit-btn {
  background: linear-gradient(45deg, #28a745, #20c997);
  color: white;
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(40, 167, 69, 0.4);
}

.modern-btn:not(.login-btn):not(.signup-btn):not(.submit-btn) {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.modern-btn:not(.login-btn):not(.signup-btn):not(.submit-btn):hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

/* Поддержка flexbox для кнопок */
.d-flex.gap-2 > .modern-btn {
  margin-right: 0.5rem;
}

.d-flex.gap-2 > .modern-btn:last-child {
  margin-right: 0;
}

/* Стили для формы регистрации */
.registration-form {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 1.5rem;
  backdrop-filter: blur(10px);
}

.registration-form .form-label {
  color: white;
  font-weight: 500;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

/* Стили для алертов в панели */
.login-panel .alert {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.1);
  color: #333;
  border-radius: 8px;
  font-size: 0.9rem;
}

.login-panel .alert-success {
  background: rgba(40, 167, 69, 0.9);
  border-color: rgba(40, 167, 69, 1);
  color: white;
}

.login-panel .alert-warning {
  background: rgba(255, 193, 7, 0.9);
  border-color: rgba(255, 193, 7, 1);
  color: #333;
}

.login-panel .alert-danger {
  background: rgba(220, 53, 69, 0.9);
  border-color: rgba(220, 53, 69, 1);
  color: white;
}

/* Адаптивность */
@media (max-width: 768px) {
  .login-page .col-md-3,
  .login-page .col-md-6,
  .login-page .col-lg-5 {
    padding: 0 1rem;
  }

  .login-panel {
    margin-right: 0;
    margin-bottom: 2rem;
    padding: 1.5rem;
    width: 100%;
  }

  .login-page .container,
  .login-page .container-fluid {
    padding: 1rem;
  }

  .modern-btn {
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }

  .registration-form {
    padding: 1rem;
  }

  .login-title {
    font-size: 1.5rem;
  }
}

/* Дополнительная адаптивность для очень маленьких экранов */
@media (max-width: 480px) {
  .login-panel {
    padding: 1rem;
    margin: 0;
    width: 100%;
  }

  .modern-input {
    font-size: 16px; /* Предотвращает зум на iOS */
    padding: 0.75rem;
  }

  .modern-btn {
    font-size: 1rem;
    padding: 0.75rem;
  }

  .login-title {
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
  }
}

p.date-header {
  position: relative;
  width: 70%;
  font-size: 1em;
  font-weight: normal;
  padding: 1px 10px 1px 25px;
  margin: 0 10px 25px 0;
  color: #ffffff;
  background-color: #17a2b8;
  text-shadow: 0px 1px 2px #bbb;
  -webkit-box-shadow: 0px 2px 4px #888;
  -moz-box-shadow: 0px 2px 4px #888;
  box-shadow: 0px 2px 4px #888;
}

p:before,
p:after {
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
}

p.date-header:after {
  left: 0px;
  top: 100%;
  border-width: 5px 5px;
  border-style: solid;
  border-color: #666 #666 transparent transparent;
}

/* Новые стили для изображения и текста */
.image-container {
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.7);
}

.overlay-text {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #4a4a4a;
  text-align: center;
  padding: 2rem;
  background: rgba(220, 219, 219, 0.35);
}

.overlay-text h3 {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.overlay-text p {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  text-shadow: 1px 1px 2px rgba(220, 219, 219, 0.35);
}

.feature-list {
  text-align: left;
}

.feature-list p {
  font-size: 1rem;
  margin-bottom: 0.3rem;
  padding-left: 0.5rem;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .image-container {
    height: 300px;
    margin-top: 2rem;
  }

  .overlay-text h3 {
    font-size: 1.5rem;
  }

  .overlay-text p {
    font-size: 1rem;
  }

  .feature-list p {
    font-size: 0.9rem;
  }
}
</style>
